import React, { Fragment } from 'react';
import Agentsslider from '../home/Agentsslider';
import Testimonials from '../home/Testimonials';
import Aboutus from './Aboutus';
import Banner from './Banner';
import Recentlisting from './Recentlisting';
import Whyus from './Whyus';

const Content = ({ recentProperties, agents }) => {
  return (
    <Fragment>
      <Banner />
      <Whyus />
      <Aboutus />
      {/* <Location /> */}
      <Recentlisting recentProperties={recentProperties} />
      {/* <Findhome /> */}
      <div className='section pb-0'>
        <Agentsslider agents={agents} />
      </div>
      <div style={{ marginTop: '-80px' }}>
        <Testimonials />
      </div>
    </Fragment>
  );
};

export default Content;
